// TutorialProvider.jsx
import React, { useState, useEffect } from 'react';
import Joyride from 'react-joyride';
import Cookies from 'js-cookie';
import { useLocation, useNavigate } from 'react-router-dom';
import TutorialPopup from './TutorialPopup';

const TutorialProvider = ({ children }) => {
  const [run, setRun] = useState(false);
  const [steps, setSteps] = useState([]);
  const [showTutorialPopup, setShowTutorialPopup] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const disablePageScroll = () => {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
  };

  const enablePageScroll = () => {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
  };

  useEffect(() => {
    const seen = Cookies.get('user_seen_tutorial');
    const storedIndex = Cookies.get('tutorial_step_index');
    const user = localStorage.getItem("USER");
  
    // ✅ Show popup only on homepage and only if not seen before
    if (!seen && location.pathname === '/') {
      setShowTutorialPopup(true);
    }
  
    // ✅ Signup Page Tutorial (only if not logged in and coming from tutorial)
    if (location.pathname === '/signup' && storedIndex === '3' && !user) {
      const waitForSignupElement = () => {
        const el = document.querySelector('.signup-form-tutorial');
        if (el) {
          setSteps([
            {
              target: '.signup-form-tutorial',
              title: 'Watch & Complete Signup',
              content: 'Seen this before? Just watch the quick video and complete your buyer or seller signup.',
              placement: 'top',
              disableBeacon: true
            }
          ]);
          setTimeout(() => {
            setRun(true);
            disablePageScroll();
          }, 100);
        } else {
          setTimeout(waitForSignupElement, 300);
        }
      };
      waitForSignupElement();
    }
  }, [location.pathname]);  

  const startTutorial = () => {
    const user = localStorage.getItem("USER");
    if (location.pathname === '/') {
      const waitForHomeElements = () => {
        const quote = document.querySelector('.get-quote-tutorial');
        const help = document.querySelector('.whatsapp-help-button');

        if (quote && help) {
          const stepsList = [
            {
              target: '.get-quote-tutorial',
              title: 'Step 1: Submit a Request — We’ll Forward It to Sellers',
              content: 'Use this form to share your product requirements — we’ll help connect you with the right suppliers.',
              placement: 'top',
              disableBeacon: true
            },
            {
              target: '.whatsapp-help-button',
              title: `Step 2: Submit ${window.inqurey} request or Talk to Us on WhatsApp` ,
              content: `Can not find your product category? You can submit your ${window.inqurey} request using the form or chat with us on WhatsApp for quick help.`,
              placement: 'top',
              disableBeacon: true
            }
          ];

          // Add signup step only if user not logged in
          if (!user) {
            stepsList.push({
              target: 'body',
              title: 'Step 3: Become a Buyer or Seller on Pakistan’s Leading B2B Platform',
              content: 'Register your business, get listed, and connect with genuine B2B buyers or sellers — all in one place.',
              placement: 'center',
              disableBeacon: true
            });
          }

          setSteps(stepsList);
          setRun(true);
          disablePageScroll();
        } else {
          setTimeout(waitForHomeElements, 300);
        }
      };
      waitForHomeElements();
    }
  };

  const handleJoyrideCallback = (data) => {
    const { index, action, status, type } = data;

    if (action === 'next' && index === 2 && location.pathname === '/') {
      Cookies.set('tutorial_step_index', '3');
      navigate('/signup');
    //   setTimeout(() => window.location.reload(), 300);
      return;
    }

    if (
      type === 'tour:end' ||
      (type === 'step:after' && (status === 'finished' || status === 'skipped')) ||
      status === 'finished' ||
      status === 'skipped'
    ) {
      Cookies.set('user_seen_tutorial', 'true', { expires: 3650 });
      Cookies.remove('tutorial_step_index');
      setRun(false);
      enablePageScroll();
    }
  };

  const handlePopupClose = () => {
    Cookies.set('user_seen_tutorial', 'true', { expires: 3650 });
    setShowTutorialPopup(false);
  };

  const handlePopupYes = () => {
    setShowTutorialPopup(false);
    startTutorial();
  };

  return (
    <>
      <Joyride
        steps={steps}
        run={run}
        continuous
        scrollToFirstStep={false}
        scrollToSteps={false}
        showSkipButton
        showProgress
        disableOverlayClose
        callback={handleJoyrideCallback}
        styles={{
          options: {
            zIndex: 9999,
            primaryColor: '#2C99A1',
            textColor: '#333',
            overlayColor: 'rgba(0, 0, 0, 0.8)',
          },
          tooltipTitle: {
            backgroundColor: '#008c99',
            color: 'white',
            marginTop: '30px',
            padding: '15px',
            borderRadius: '10px'
          }
        }}
        locale={{ last: 'Finish' }}
        spotlightClicks={true}
      />
      <TutorialPopup show={showTutorialPopup} onClose={handlePopupClose} onYes={handlePopupYes} />
      {children}
    </>
  );
};

export default TutorialProvider;
